<div class="out">
  <div class="horizontal-viewport">
    <div class="horizontal-data">
      <img *ngFor="let image of _asset.images; let i = index" class="image-box"  kzLib (click)="selected(i)" [src]="image.url" />
    </div>
  </div>
</div>
